import { useMemo } from 'react';

import PreviewFwdCurveChart from '@/features/DataHub/components/Preview/ChartPreviews/PreviewFwdCurveChart';
import PreviewSeasonalChart from '@/features/DataHub/components/Preview/ChartPreviews/PreviewSeasonalChart';
import PreviewSpotChart from '@/features/DataHub/components/Preview/ChartPreviews/PreviewSpotChart';
import { useExportMeta } from '@/features/DataHub/modules/Export/context/ExportMetaContext';
import { useAppSelector } from '@/hooks/redux-hooks';

const Preview = () => {
  const { type: exportType, from } = useAppSelector(state => state.export);
  const { uniqueSymbols } = useExportMeta();
  const symbols = useMemo(() => Array.from(uniqueSymbols), [uniqueSymbols]);
  if (!exportType || exportType === 'spot') {
    return (
      <PreviewSpotChart
        symbols={symbols}
        type={exportType}
      />
    );
  }
  if (exportType === 'forwardSimple') {
    return (
      <PreviewFwdCurveChart
        symbols={symbols}
        type={exportType}
      />
    );
  }
  if (exportType === 'seasonal') {
    return (
      <PreviewSeasonalChart
        from={from}
        symbols={symbols}
        type={exportType}
      />
    );
  }
  return null;
};
export default Preview;
